var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9966 3.1723C12.2263 2.94257 12.598 2.94256 12.8277 3.1723C13.0574 3.40204 13.0574 3.77367 12.8277 4.00341L8.83111 8L12.8277 11.9966C13.0574 12.2263 13.0574 12.598 12.8277 12.8277C12.598 13.0574 12.2263 13.0574 11.9966 12.8277L8 8.83111L4.00341 12.8277C3.77367 13.0574 3.40204 13.0574 3.1723 12.8277C2.94256 12.598 2.94257 12.2263 3.1723 11.9966L7.16889 8L3.1723 4.00341C2.94257 3.77367 2.94256 3.40204 3.1723 3.1723C3.40204 2.94257 3.77367 2.94257 4.00341 3.1723L8 7.16889L11.9966 3.1723Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "close.bea448214cdb1cc2e934c0f629b6c1f0.svg";